import { colors } from '../styles'

export default colors
